import { render, staticRenderFns } from "./COAAllocationModal2.vue?vue&type=template&id=5c211cda&scoped=true&"
import script from "./COAAllocationModal2.vue?vue&type=script&lang=js&"
export * from "./COAAllocationModal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c211cda",
  null
  
)

export default component.exports